import React from 'react';
import "./App.css";
import { connect } from 'react-redux';
import axios from 'axios';
import Storage from './components/Storage';
import { IntlProvider } from "react-intl";
import { __API_FLOORPLANS_URL__, __API_STANDS_URL__, __API_VIRTUAL_BASIC_INFO__, __API_ROOMS_URL__ } from './consts/consts';
import { store } from './index'
import { changeLocale } from './redux/actionsTypes';
import Utils from './components/Utils';
import AppLocale from './lang';
import { socket } from './index';
import Spinner from './components/Spinner';
import ProgrammeView from './views/programme/programmeView';
import styles from './app.module.css';

class App extends React.Component {
	constructor(props) {
		super(props);
		this.state = { isAuthenticated: false, registrationType: '', isLoading: false };
		let isAuthenticated = Storage.getIsAuthenticated();
		this.lastUpdate = null;
		//	this.updater = setInterval(this.timer(this), 30000);//Cada 5 min actualizo
		//  isAuthenticated = false;

		this.state = {
			isAuthenticated: isAuthenticated,
			registrationType: Storage.getRegistrationType(),
			isLoading: isAuthenticated,
			isLoadingPreLoginInfo: !isAuthenticated
		};//Si esta autenticado lo hago que este este cargando
	}


	timer() {
		if (this.lastUpdate == null || new Date() - this.lastUpdate > (1000 * 60 * 5 - 5000)) {
			//Si paso mas de 4'55''
			this.loadMapping(function () { }, false);
			//Borro el programa para invalidarlo
			Storage.clearProgramme();
		}
	}


	componentDidMount() {
		Storage.saveURLParams()
		Storage.saveProcessedURLParams();
		this.intervalId = setInterval(this.timer.bind(this), 1000 * 60 * 5);
		if (window.location.protocol != "https:" && (window.location.port == 0 || window.location.port == '')) {
			window.location.protocol = "https";
		}
	}

	componentWillUnmount() {
		clearInterval(this.intervalId);
	}


	onLogout() {
		Storage.clearAll();
		this.setState({ isAuthenticated: false, registrationType: '', isLoading: false })
	}


	loadMapping(callback, removeStands) {
		return;
	}

	componentWillMount() {
		//START OF SITE CODE
		if (Storage.getIsAuthenticated()) {
			//Lo tengo que llamar cada vez que se monta porque sino el socket se cierra dsps del f5
			this.createSocketAndLoadStands();
		}
		const eventId = window.location.pathname.split('&')[0].replace('/AcEventId=', '');
		const storedEventId = Storage.getIdEvent();
		if (eventId !== storedEventId) {
			Storage.clearAll()
		}
		window.localStorage.setItem('AcEventId', eventId);
		// this.getBasicEventInfoAndRoomData();
		this.injectScript()
	}

	injectScript() {
		const scriptFromAPI = Storage.getStartupScript()

		if (scriptFromAPI) {
			const scriptElement = document.createElement('script')
			scriptElement.innerText = scriptFromAPI
			document.body.appendChild(scriptElement)
		}
	}

	getBasicEventInfoAndRoomData() {
		const numericIdEvent = Storage.getIdEvent();
		const requestVirtualBasicInfo = axios.get("https://api.kingconf.com/v3.0/events/" + numericIdEvent + "/virtualBasicInfo")
		const requestRooms = axios.get('https://api.kingconf.com/v3.0/events/' + numericIdEvent + '/rooms')
		axios.all([requestVirtualBasicInfo, requestRooms]).then(axios.spread((...responses) => {
			var respVirtualBasicInfo = responses[0].data
			var respRooms = responses[1].data

			Storage.saveEventBasicInfo(respVirtualBasicInfo)
			Storage.saveRoomsInfo(respRooms)
			const currentLanguage = window.localStorage.getItem('currentLanguange')
			if (!currentLanguage) {
				store.dispatch(changeLocale(respVirtualBasicInfo.mainLanguage.toLowerCase()))
			}
			if (respVirtualBasicInfo.virtualCssStyles != null && respVirtualBasicInfo.virtualCssStyles != '')
				Utils.insertCss(respVirtualBasicInfo.virtualCssStyles);
			this.setState({ isLoadingPreLoginInfo: false })


		})).catch(error => {
			console.log("Error Fetching VirtualBasicInfo or RoomsInfo on App")
			console.log(error)
		})

	}

	createSocketAndLoadStands() {
		var me = this;
		try {
			socket.create();
			socket.start();
			this.loadMapping(function () {
				me.setState({ isLoading: false });
			});
		}
		catch (error) {
		}
	}

	onLoginSuccessHandler(jwtToken, registrationType, idPerson) {
		Storage.storeCredentials(jwtToken, registrationType, idPerson);

		Storage.recreateMenu();
		this.setState({ isAuthenticated: true, isLoading: true });
		this.createSocketAndLoadStands();
	}

	render() {
		document.title = Storage.getEventTitle()
		const { locale } = this.props;
		const currentAppLocale = AppLocale[locale];
		if (this.state.isLoading) {
			return (
				<IntlProvider messages={Object.assign({}, currentAppLocale.messages, Utils.getLanguageOverride(currentAppLocale.locale))} >
					<div className="full-screen">
						<Spinner />
					</div>
				</IntlProvider>
			);
		}

		return (
			<div className={styles.appContainer}>
				<IntlProvider
					locale={Storage.getMainLanguage()}
					messages={Object.assign({}, currentAppLocale.messages, Utils.getLanguageOverride(currentAppLocale.locale))}
				>
					<ProgrammeView />
				</IntlProvider>
			</div>
		);
	}
}

const mapStateToProps = ({ settings }) => {
	const { locale } = settings;
	return { locale };
};
const mapActionsToProps = {};

export default connect(mapStateToProps, mapActionsToProps)(App);